/** The fields of `WorkspaceBudget` the action bar reads (WRT-13). */ function fmtPages(n) {
    return Number.isInteger(n) ? String(n) : n.toFixed(1);
}
/**
 * "298 words · about 0.6 pages", "1,640 words · 3.1 of 4 pages",
 * "4 of 10 pages" when measured. Estimates read "about"; a limit adds "of N".
 */ export function budgetText(b) {
    const words = `${b.words.toLocaleString('en-US')} words`;
    const wordPart = b.wordLimit > 0 ? `${words} of ${b.wordLimit.toLocaleString('en-US')}` : words;
    const about = b.pagesBasis === 'estimate' ? 'about ' : '';
    const limit = b.pageLimit > 0 ? ` of ${fmtPages(b.pageLimit)}` : '';
    const unit = b.pageLimit <= 0 && b.pages === 1 ? 'page' : 'pages';
    return `${wordPart} · ${about}${fmtPages(b.pages)}${limit} ${unit}`;
}
/** Tooltip explaining where the page count comes from. */ export function budgetBasisText(b) {
    switch(b.pagesBasis){
        case 'exact':
            return 'Pages measured by rendering this version to PDF.';
        case 'app_xml':
            return 'Pages as the editor last saved them in the document. Check exact pages to measure.';
        default:
            return `Estimated at ${b.wordsPerPage || 500} words per page. Check exact pages to measure.`;
    }
}
/** True when the budget is over its page or word limit. */ export function overBudget(b) {
    return b.pageLimit > 0 && b.pages > b.pageLimit || b.wordLimit > 0 && b.words > b.wordLimit;
}
